var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../propTypes", "../../css", "../../UI/Interchange/Interchange", "../../UI/Icon/ArteVertical", "../../UI/Icon/Icon", "./TeaserBrochure.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../propTypes"), require("../../css"), require("../../UI/Interchange/Interchange"), require("../../UI/Icon/ArteVertical"), require("../../UI/Icon/Icon"), require("./TeaserBrochure.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.propTypes, global.css, global.Interchange, global.ArteVertical, global.Icon, global.TeaserBrochure);
    global.TeaserBrochure = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _propTypes2, _css, _Interchange, _ArteVertical, _Icon, _TeaserBrochure) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);
  _ArteVertical = _interopRequireDefault(_ArteVertical);
  _Icon = _interopRequireDefault(_Icon);

  var TeaserBrochure = function TeaserBrochure(_ref) {
    var className = _ref.className,
        images = _ref.images,
        title = _ref.title,
        url = _ref.url,
        hover = _ref.hover,
        visible = _ref.visible,
        icon = _ref.icon,
        withArteLogo = _ref.withArteLogo,
        breakpointFormat = _ref.breakpointFormat;
    return /*#__PURE__*/_react.default.createElement(_TeaserBrochure.StyledLink, {
      href: url,
      className: className
    }, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
      breakpointFormat: breakpointFormat,
      images: images,
      placeholder: false,
      hover: _css.hovers[hover],
      title: title,
      visible: visible
    }, /*#__PURE__*/_react.default.createElement(_TeaserBrochure.StyledContainer, null, icon && /*#__PURE__*/_react.default.createElement(_TeaserBrochure.StyledIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: icon,
      size: "mediumSmall"
    })), withArteLogo && /*#__PURE__*/_react.default.createElement(_TeaserBrochure.StyledLogo, null, /*#__PURE__*/_react.default.createElement(_ArteVertical.default, {
      size: "xxsmall"
    })), title && /*#__PURE__*/_react.default.createElement(_TeaserBrochure.StyledTitle, null, title))));
  };

  TeaserBrochure.propTypes = {
    images: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    title: _propTypes.default.string.isRequired,
    icon: _propTypes.default.string,
    url: _propTypes.default.string.isRequired,
    visible: _propTypes.default.bool,
    withArteLogo: _propTypes.default.bool,
    breakpointFormat: _propTypes.default.shape(),
    hover: _propTypes.default.string,
    className: _propTypes.default.string
  };
  TeaserBrochure.defaultProps = {
    className: 'next-teaser',
    visible: true,
    icon: 'arte-icon--download',
    withArteLogo: false,
    breakpointFormat: _propTypes2.default.breakpointFormat,
    hover: 'basic',
    title: ''
  };
  var _default = TeaserBrochure;
  _exports.default = _default;
});